<template>
  <div class="profile-gallery">
    <viewer :images="images" class="images-list" style="margin-right: 20px">
      <!--<img v-for="i in 50" :key="i" v-lazy="'/static/images/gallery/photo-'+i+'.jpg'" alt="gallery image">-->
      <!-- lazy load -->
      <div v-for="i in images" :key="i" :src="i">
        <!-- <template> -->
        <span
          class="closes"
          style="cursor: pointer; position: absolute; margin-right: 150px"
          role="button"
          @click="handleDelete(i)"
        >
          <i class="el-icon-delete danger"></i>
        </span>
        <img :src="i" alt="" class="img-responsive" />
        <!-- </template> -->
      </div>

      <!-- <el-button type="button" icon="icon-delete"></el-button> -->
    </viewer>
    <el-button type="info" style="margin-top: 15px" @click="handlerBack"
      >volver atras</el-button
    >
  </div>
</template>

<script>
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
Vue.use(Viewer);
export default {
  name: "ProfileGallery",
  props: {
    images: {
      type: Array,
      required: true
    },
    isOwner: {
      type: Boolean
    }
  },
  methods: {
    handlerBack() {
      this.$router.go(-1);
    },
    handleDelete(value) {
      let parameter = value;

      this.$confirm("Desea aliminar esta imagen?", "Confirmación", {
        confirmButtonText: "Si",
        cancelButtonText: "Cancelar",
        type: "warning"
      })
        .then(() => {
          // delete
          this.$http
            .delete(`/api/gallery/DeletePhoto?uri=${parameter}`)
            .then(() => {
              this.$emit("delete");
              this.$message({
                type: "success",
                message: "Imagen eliminada"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Operacion cancelada"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/_variables";

.profile-gallery {
  /*.images-list {
		margin: 0 -10px;
		margin-top: -10px;

		img {
			cursor: pointer;
			width: calc(50% - 20px);
			border-radius: 10px;
			max-width: 278px;
			float: left;
			box-sizing: border-box;
			margin: 10px;
			border: 5px solid #fff;
			box-shadow: 0px 7px 20px -7px rgba(0, 0, 0, 0.55);
			transition: all .5s;

			&:hover {
				box-shadow: none;
				transform: translateY(3px);
			}
		}
	}*/
  flex-direction: row;
  .images-list {
    overflow: hidden;
    margin: -1%;
    &.box-margins {
      margin: 1%;
    }

    img {
      cursor: pointer;
      width: 18%;
      border-radius: 10px;
      //max-width: 278px;
      float: left;
      box-sizing: border-box;
      margin: 1%;
      border: 5px solid #fff;
      box-shadow: 0px 7px 20px -7px rgba(0, 0, 0, 0.55);
      transition: all 0.5s;

      &:hover {
        box-shadow: none;
        transform: translateY(3px);
      }
    }
  }
}

@media (max-width: 768px) {
  .profile-gallery {
    .images-list {
      margin: -1.5%;
      &.box-margins {
        margin: 1.5%;
      }

      img {
        width: 30.3%;
        margin: 1.5%;
      }
    }
  }
}
@media (max-width: 480px) {
  .profile-gallery {
    .images-list {
      margin: -2%;
      &.box-margins {
        margin: 2%;
      }

      img {
        width: 46%;
        margin: 2%;
      }
    }
  }
}
@media (max-width: 360px) {
  .profile-gallery {
    .images-list {
      margin: -2%;
      &.box-margins {
        margin: 2%;
      }

      img {
        width: 96%;
        margin: 2%;
      }
    }
  }
}

.img-wraps {
  position: relative;
  display: inline-block;

  font-size: 0;
}
.img-wraps .closes {
  position: absolute;
  top: 5px;
  right: 8px;
  z-index: 100;
  background-color: #fff;
  padding: 4px 3px;

  color: #000;
  font-weight: bold;
  cursor: pointer;

  text-align: center;
  font-size: 22px;
  line-height: 10px;
  border-radius: 50%;
  border: 1px solid red;
}
.img-wraps:hover .closes {
  opacity: 1;
}
</style>
